var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 24.7,
    rx: 0.75,
    fill: "#F7FCFF",
    stroke: "#FE3E9A",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1499 3.1499H25.1999V6.2999H3.1499V3.1499Z",
    fill: "#FE3E9A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.1499,
    y: 9.44995,
    width: 3.15,
    height: 3.15,
    rx: 0.25,
    fill: "#FE3E9A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.4502,
    y: 9.44995,
    width: 3.15,
    height: 3.15,
    rx: 0.25,
    fill: "#FE3E9A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.4502,
    y: 14.175,
    width: 3.15,
    height: 3.15,
    rx: 0.25,
    fill: "#4BA97C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.75,
    y: 9.44995,
    width: 3.15,
    height: 3.15,
    rx: 0.25,
    fill: "#FE3E9A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0498,
    y: 9.44995,
    width: 3.15,
    height: 3.15,
    rx: 0.25,
    fill: "#FE3E9A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3.1499,
    y: 14.175,
    width: 3.15,
    height: 3.15,
    rx: 0.25,
    fill: "#FE3E9A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15.75,
    y: 14.175,
    width: 3.15,
    height: 3.15,
    rx: 0.25,
    fill: "#FE3E9A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0498,
    y: 14.175,
    width: 3.15,
    height: 3.15,
    rx: 0.25,
    fill: "#FE3E9A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 9.4502,
    y: 18.8999,
    width: 3.15,
    height: 3.15,
    rx: 0.25,
    fill: "#FE3E9A"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 3.1499,
    y: 18.8999,
    width: 3.15,
    height: 3.15,
    rx: 0.25,
    fill: "#FE3E9A"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 15.75,
    y: 18.8999,
    width: 3.15,
    height: 3.15,
    rx: 0.25,
    fill: "#FE3E9A"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0498,
    y: 18.8999,
    width: 3.15,
    height: 3.15,
    rx: 0.25,
    fill: "#FE3E9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.3ac0da8f7836757c66923602e0f0027f.svg";
export { ForwardRef as ReactComponent };